module.exports = __webpack_public_path__ + "static/img/logo-mobile.24855cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-mobile.svg
// module id = vxJq
// module chunks = 1